<template>
  <div>

    <div class="attention-zones-list">
      <exercises-item
          v-for="(item, index) in dataTable"
          :key="index"
          :index="index"
          :item="item"
          @delete="deleteItem(index)"
          @editItem="editItem"
          :types="types()"/>
    </div>

    <el-button
        @click="addItem"
        type="primary"
        icon="el-icon-plus"
        class="attention-zones-list__btn">Добавить систему
    </el-button>
  </div>
</template>

<script>
import ExercisesItem from "@/components/Exercises/Item.vue"

export default {
  name: 'AttentionZonesList',
  props: {
    dataTable: {}
  },
  components: {
    ExercisesItem
  },
  data() {
    return {
      editable: false,
      zonesList: {}
    }
  },
  created() {
    this.zonesList = JSON.parse(JSON.stringify(this.dataTable))
  },
  methods: {
    addItem() {
      this.dataTable.push({
            "code": '',
            "icon": "",
            "title": "",
            "zones": ""
          }
      )
    },
    deleteItem(index) {
      this.dataTable.splice(index, 1)
    },
    editItem(element, newValue) {
      console.log(this.dataTable[element])
      this.dataTable[element].title = newValue.title
      this.dataTable[element].icon = newValue.icon
      this.dataTable[element].zones = newValue.zones
    },
    types() {
      let arr = this.zonesList.map(item => {
        return {
          code: item.code,
          title: item.title,
          icon: item.icon
        }
      })

      return arr
    }
  }
}
</script>

<style lang="scss" scoped>

.attention-zones-list {

  &__btn {
    width: 100%;

    font-weight: 500 !important;
    font-size: 14px !important;
    line-height: 22px !important;
    border-radius: 4px !important;
  }

}

.food-products {

  &__title {
    padding: 19px 0;
    margin-left: 16px;

    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #111;
  }

  &__recommended {
    font-size: 11px;
    line-height: 13px;
    color: #111;
  }

  .unwanted {
    display: flex;

    justify-content: space-between;
    align-items: center;

    &__title {
      font-size: 11px;
      line-height: 13px;
      color: #111;
    }

    &__edit {
      font-size: 11px;
      line-height: 13px;
      color: #111;
    }

  }

  &__icon-block {
    display: flex;
    align-items: center;
    justify-content: flex-start;

  }

  &__select {
    margin-left: 16px;
  }

}

</style>